import React from 'react';
import { SwitchInput } from '@thinknet-gmbh/platform-common-ui';

export const BooleanSwitchInfo = ({
  t,
  defaultChecked,
  disabled = true
}: {
  t: Function;
  disabled?: boolean;
  defaultChecked?: boolean;
}) => {
  return (
    <SwitchInput
      checkedChildren={t('common:labels.yes')}
      size={'small'}
      unCheckedChildren={t('common:labels.no')}
      disabled={disabled}
      defaultChecked={defaultChecked}
    />
  );
};

export default BooleanSwitchInfo;
